import { Alert } from '@mui/material';
import { Field, useField } from 'formik';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import * as Yup from 'yup';

import { Section, SectionTitle } from '..';
import { pluralize, pluralizeRu, useAppSelector, widgetBreakDurationSchema } from '../../../../lib';
import { configSelectors } from '../../../../store';
import { InputField } from '../../../fields';

export const DisplaySettings = () => {
  const widgetBreakDurationSliceName = 'campaign.widgetBreakDuration';
  const isStandalone = useAppSelector(configSelectors.isStandalone);

  const { t } = useTranslation();

  const [field] = useField<number>(widgetBreakDurationSliceName);

  const validate = (value: string, schema: Yup.AnySchema) => {
    try {
      schema.validateSync(value);
    } catch (error) {
      return (error as any).message;
    }
  };

  const helperText = isStandalone
    ? `Пользователь сможет сыграть снова через ${field.value} ${pluralizeRu(
        field.value,
        'час',
        'часа',
        'часов'
      )}`
    : `User can play next time in ${field.value} ${pluralize(field.value, 'hour', 'hours')}`;

  return (
    <DisplaySettingsWrapper>
      <Section elevation={0}>
        <SectionTitle>{t('pages.campaign.displaySettings')}</SectionTitle>

        <Field
          name={widgetBreakDurationSliceName}
          component={InputField}
          label={t('pages.campaign.dismissPeriod')}
          type="number"
          helperText={helperText}
          validate={(value: string) => validate(value, widgetBreakDurationSchema)}
          className="form-field"
        />

        {field.value ? (
          <Alert variant="filled" severity="info">
            {t('pages.campaign.dismissPeriodInfo')}
          </Alert>
        ) : null}
      </Section>
    </DisplaySettingsWrapper>
  );
};

const DisplaySettingsWrapper = styled.div`
  .form-field {
    width: 290px;
    margin-bottom: 24px;

    :last-child {
      margin-bottom: 0;
    }
  }
`;
